export enum ResourceType {
  PRODUCT = "product",
  MEDIA = "media",
  CATALOG = "catalog",
}
